/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Редактировать дашбоард.
 */
export interface DashboardEdit { 
    /**
     * ID ассоциации.
     */
    parentOrganisationId?: string;
    /**
     * Текст.
     */
    noticeText?: string;
    /**
     * Групповой чат.
     */
    groupId?: number;
    /**
     * Канал.
     */
    channelId?: number;
    /**
     * ID записи.
     */
    id?: string;
}

